(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kb-product-breadcrumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kb-product-breadcrumbs')) {
  customElements.define('kb-product-breadcrumbs', class extends HTMLElement {
    connectedCallback() {
      this.align = () => {
        const image = this.closest('.product-information')?.querySelector('.product-information__media .product-media__image');
        const nav = this.querySelector('nav');
        if (!image || !nav) return;
        const inset = Math.max(0, image.getBoundingClientRect().left - this.getBoundingClientRect().left);
        nav.style.paddingInlineStart = `${inset}px`;
      };
      this.observer = new ResizeObserver(this.align);
      const section = this.closest('.product-information');
      if (section) this.observer.observe(section);
      const image = section?.querySelector('.product-information__media .product-media__image');
      if (image) this.observer.observe(image);
      window.addEventListener('resize', this.align);
      this.align();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.align);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
